var SnStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { SharedConstants } from "../../constants/shared.constants";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject, throwError } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { AppControllerService } from "../../../app-controller.service";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { Router } from "@angular/router";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { minLengthArray } from "../../classes/min-length-array-validator";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { ViewApplicationDetailsSnComponent } from "../../../application/view-application/modules/sn/view-application-details-sn/view-application-details-sn.component";
import { ViewApplicationLocationSnComponent } from "../../../application/view-application/modules/sn/view-application-location-sn/view-application-location-sn.component";
import { CreateApplicationDetailsSnComponent } from "../../../application/create-application/modules/sn/create-application-details-sn/create-application-details-sn.component";
import { CreateApplicationLocationSnComponent } from "../../../application/create-application/modules/sn/create-application-location-sn/create-application-location-sn.component";
import { ModuleConfig } from "../../models/module-config.model";
import _ from "underscore";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { SearchApplicantAgentComponent } from "../../../tabs/applications/application-search/search-applicant-agent/search-applicant-agent.component";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchApplicantInfoComponent } from "../../../tabs/applications/application-search/search-applicant-info/search-applicant-info.component";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { ApiStreetNamingConstants } from "../../constants/api-constants/api-street-naming.constants";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { AlertType } from "../../models/alert";
import RecipientUtils from "../../utils/recipient-utils";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ModulePrefix } from "../../models/module-prefix.model";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var SNSearchOptions;
(function (SNSearchOptions) {
    SNSearchOptions["ReferenceNumber"] = "Reference Number";
    SNSearchOptions["MyApplications"] = "My Applications";
    SNSearchOptions["ApplicantAgent"] = "Applicant Agent";
    SNSearchOptions["ApplicantInfo"] = "Applicant Information";
    SNSearchOptions["AppID"] = "Application ID";
    SNSearchOptions["ApplicationStatus"] = "Application Status";
    SNSearchOptions["ApplicationCategory"] = "Application Category";
    SNSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    SNSearchOptions["AssignedToUsers"] = "Assigned to";
    SNSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    SNSearchOptions["CreatedDate"] = "Created Date";
    SNSearchOptions["CreatedDateRange"] = "Created Date Range";
    SNSearchOptions["StartDate"] = "Started Date";
    SNSearchOptions["StartDateRange"] = "Started Date Range";
    SNSearchOptions["DaysUntilExpired"] = "Days until Expired";
    SNSearchOptions["PercentageComplete"] = "Percentage Complete";
    SNSearchOptions["TimeoutStatus"] = "Timeout Status";
    SNSearchOptions["JobID"] = "Job ID";
})(SNSearchOptions || (SNSearchOptions = {}));
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ErfNumber, "erfNumbers"],
    [ApplicationHeadingEnum.ApplicationType, "type"],
    [ApplicationHeadingEnum.StartDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "type"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const SNSearchQueryLookup = new Map([
    [SNSearchOptions.AppID, "appId"],
    [SNSearchOptions.ReferenceNumber, "referenceNumber"],
    [SNSearchOptions.JobID, "jobId"]
]);
export const SNAdditionalSearchOptions = [SNSearchOptions.MyApplications,
    SNSearchOptions.AssignedToUsers,
    SNSearchOptions.UnassignedApplications,
    SNSearchOptions.ApplicationsWithoutStartDate];
export const SNDateSearchOptions = new Map([
    [SNSearchOptions.CreatedDate, 1],
    [SNSearchOptions.CreatedDateRange, 2],
]);
export const SNStartRangeDateSearchOptions = new Map([
    [SNSearchOptions.StartDate, 1],
    [SNSearchOptions.StartDateRange, 2],
]);
export const SNStatusSearchOptions = new Map([
    [SNSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
    [SNSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
    [SNSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [SNSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const SNSearchOptionClientHeight = new Map([
    [SNSearchOptions.ReferenceNumber, SearchContainerHeight.Simple],
    [SNSearchOptions.MyApplications, SearchContainerHeight.Simple],
    [SNSearchOptions.AppID, SearchContainerHeight.Simple],
    [SNSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine],
    [SNSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine],
    [SNSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine],
    [SNSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine],
    [SNSearchOptions.CreatedDate, SearchContainerHeight.SingleLine],
    [SNSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine],
    [SNSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine],
    [SNSearchOptions.ApplicantAgent, SearchContainerHeight.Extended],
    [SNSearchOptions.ApplicantInfo, SearchContainerHeight.Extended]
]);
export var SnSearchOptionTableListEnum;
(function (SnSearchOptionTableListEnum) {
    SnSearchOptionTableListEnum["Application"] = "SN_APPLICATION|Application";
    SnSearchOptionTableListEnum["Property"] = "SN_APPLICATIONLOCATION";
    SnSearchOptionTableListEnum["Owner"] = "AFLA_Recipient|Owners";
    SnSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    SnSearchOptionTableListEnum["ApplicationType"] = "SN_APPLICATION|Application";
    SnSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    SnSearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
})(SnSearchOptionTableListEnum || (SnSearchOptionTableListEnum = {}));
export const SNExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_SN;
export const SNTableNameListForSearchOptions = SnSearchOptionTableListEnum.Application
    + "," + SnSearchOptionTableListEnum.Property
    + "," + SnSearchOptionTableListEnum.Owner
    + "," + SnSearchOptionTableListEnum.Status
    + "," + SnSearchOptionTableListEnum.ApplicationType
    + "," + SnSearchOptionTableListEnum.Applicant
    + "," + SnSearchOptionTableListEnum.ApplicantAgent;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["ApplicantAgent"] = "Applicant / agent";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant / applicant agent";
    ViewApplicationMenuHeadings["Location"] = "Location";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const SnRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "TotalValue", type: EsriDataTypeEnum.integer },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
let SnStrategyService = class SnStrategyService extends AflaModuleStrategyService {
    static { SnStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    buildingUseSearchOptions;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.StreetNaming;
    modulePrefix = ModulePrefix.StreetNaming;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
    applicationServiceUrl = ApiStreetNamingConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = SNExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = SNExpandListForApplicationSearch;
    searchOptionTableNameList = SNTableNameListForSearchOptions;
    customApplicationTableColumnMap = null;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Welcome page",
        "Application help",
        "Property help",
        "Applicant help",
        "Agent help",
        "Required documentation help",
        "Notes help",
        "Summary help",
        "Create application status page",
        "View application status page",
        "Communication help"
    ];
    stampOptions = [];
    previousApplication = null;
    moduleRequiredMaps;
    setApplicantAndApplicantAgentAction = ApiStreetNamingConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Properties";
    statusColumn = "status/ workflowSection";
    createApplicationSn;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router, recipientSelectService) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.STREET_NAMING_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Properties"];
        this.requiredMapFields = SnRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on a child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, SNExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = SnStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = SNSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = SNAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(SNSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(SNSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = SNDateSearchOptions;
        this.RangeSearchOptions = SNStartRangeDateSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = SNStatusSearchOptions;
        this.clientHeightMap = SNSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: SnStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: SnStrategyService_1.getRecipientName(SnStrategyService_1.getFirstRecipient(application.applicant)),
            agent: SnStrategyService_1.getRecipientName(SnStrategyService_1.getFirstRecipient(application.applicantAgent)),
            type: application.type,
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue
                    && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                case "applicantagent":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                        break;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                case "location":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size)
            || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(SnSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsSnComponent,
            ],
            [
                ViewApplicationMenuHeadings.Location,
                ViewApplicationLocationSnComponent,
            ],
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsSnComponent,
            ],
            [
                CreateApplicationMenuHeadings.Location,
                CreateApplicationLocationSnComponent,
            ]
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            [SNSearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [SNSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [SNSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [SNSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [SNSearchOptions.StartDate, SearchStartDateComponent],
            [SNSearchOptions.StartDateRange, SearchStartDateComponent],
            [SNSearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [SNSearchOptions.PercentageComplete, SearchStatusComponent],
            [SNSearchOptions.ApplicationStatus, SearchStatusComponent],
            [SNSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [SNSearchOptions.TimeoutStatus, SearchStatusComponent],
            [SNSearchOptions.DaysUntilExpired, SearchStatusComponent]
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID) {
        let params = SnStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), SnStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = SnStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, SnStrategyService_1.buildModuleIDFilter(moduleID), SnStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = SnStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateItApplication");
        const application = this.buildApplication();
        this.createApplicationSn =
            this.postApplicationService(application)
                .subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(SnStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                    this.resetForm();
                    this.requestStatusService.removeBusySpinner("CreateItApplication");
                    this.router.navigate([
                        AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                        {
                            jobId: savedApplication.jobId,
                            moduleId: this.appController.selectedModuleID,
                            type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                        }
                    ]);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("CreateItApplication");
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "line, polygon",
            $expand: "line, polygon",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
        this.form.get("locationForm").get("features").clear();
        this.form.get("noteForm").get("notes").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiStreetNamingConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, location, lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_SN_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_SN_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_SN_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiStreetNamingConstants.URL}/${applicationId}/${ApiStreetNamingConstants.FUNCTION_GET_GENERATE_INVOICE}`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiStreetNamingConstants.URL}/${applicationId}/${ApiStreetNamingConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        const params = {
            jobId: jobId,
            category: category
        };
        return this.http.get(`${ApiStreetNamingConstants.URL}/${moduleId}/${ApiStreetNamingConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const locationArray = this.form.get("locationForm").get("features");
        const streetOrFeatureValue = locationArray.controls[0].get("streetOrFeature").value;
        const streetNamingApplication = {
            id: 0,
            referenceNumber: "",
            deleted: false,
            wkid: 102100,
            moduleId: Number(this.appControllerService.selectedModuleID),
            decision: ""
        };
        this.setApplicationDetails(streetNamingApplication);
        this.setApplicantAndApplicantAgentDetails(streetNamingApplication);
        this.setLocationDetails(streetNamingApplication, locationArray);
        this.setNotesDetails(streetNamingApplication);
        if (streetOrFeatureValue?.toLowerCase() === "feature") {
            this.setApplicationPolygon(streetNamingApplication, locationArray);
        }
        if (streetOrFeatureValue?.toLowerCase() === "street") {
            this.setApplicationLine(streetNamingApplication, locationArray);
        }
        return streetNamingApplication;
    }
    initForm() {
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
                applicantAgentRecipient: new FormControl(null),
                copyApplicantDetails: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                type: new FormControl(null, [Validators.required]),
                referenceNumber: new FormControl(null)
            }),
            locationForm: new FormGroup({
                features: new FormArray([], [minLengthArray(1), Validators.required])
            }),
        });
    }
    setApplicationDetails(streetNamingApplication) {
        streetNamingApplication.description = this.form.get("detailsForm").get("description").value;
        streetNamingApplication.type = this.form.get("detailsForm").get("type").value;
    }
    setApplicantAndApplicantAgentDetails(streetNamingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        streetNamingApplication.applicant = [applicant];
        const markApplicantAgentAsNotApplicable = this.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").value;
        streetNamingApplication.applicantAgentNa = !markApplicantAgentAsNotApplicable;
        const copyApplicantDetails = this.form.get("applicantForm").get("copyApplicantDetails").value;
        let applicantAgent = null;
        const applicantAgentRecipientFormControl = this.form.get("applicantForm").get("applicantAgentRecipient");
        if (copyApplicantDetails) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, applicantAgentRecipientFormControl, true);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            const applicantAgentFormValue = this.form.get("applicantForm").get("applicantAgentRecipient").value;
            applicantAgent = RecipientUtils.removeRecipientProperties(applicantAgentFormValue);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            streetNamingApplication.applicantAgent = [applicantAgent];
        }
    }
    setLocationDetails(streetNamingApplication, locationArray) {
        locationArray.controls.forEach((selectedLocation) => {
            const location = {
                id: 0,
                streetOrFeature: selectedLocation.get("streetOrFeature").value,
                publicOrPrivate: selectedLocation.get("publicOrPrivate").value,
                areaEstateName: selectedLocation.get("areaEstateName").value,
                isNewDevelopment: selectedLocation.get("isNewDevelopment").value,
                haveExistingName: selectedLocation.get("haveExistingName").value,
                currentName: selectedLocation.get("currentName").value,
                locationDescription: selectedLocation.get("locationDescription").value,
                ward: selectedLocation.get("ward").value,
                proposedName: selectedLocation.get("proposedName").value,
                proposedNameLanguage: selectedLocation.get("proposedNameLanguage").value,
                proposedNameMeaning: selectedLocation.get("proposedNameMeaning").value,
                proposedNameOrigin: selectedLocation.get("proposedNameOrigin").value,
                featureType: selectedLocation.get("featureType").value,
                reasonForChange: selectedLocation.get("reasonForChange").value,
                alternativeNames: selectedLocation.get("alternativeNames").value,
                deleted: false,
            };
            streetNamingApplication.location = location;
        });
    }
    setNotesDetails(streetNamingApplication) {
        const notes = [];
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((noteItem) => {
            const note = {
                note: noteItem.get("note").value,
            };
            notes.push(note);
        });
        streetNamingApplication.notes = notes;
    }
    setApplicationPolygon(streetNamingApplication, locationArray) {
        const points = [];
        locationArray.controls.forEach((selectedLocationItem) => {
            const centroid = selectedLocationItem.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
        });
        const applicationShape = `POINT ${points.join(", ")}`;
        const selectedLocationFormGroup = locationArray.controls[0];
        const geometry = selectedLocationFormGroup.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        streetNamingApplication.polygon = {
            id: 0,
            deleted: false,
            shape: geometryJSON,
            wkid: 102100,
        };
        streetNamingApplication.shape = applicationShape;
    }
    setApplicationLine(streetNamingApplication, locationArray) {
        const points = [];
        locationArray.controls.forEach((selectedLocationItem) => {
            const centroid = selectedLocationItem.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
        });
        const applicationShape = `POINT ${points.join(", ")}`;
        const selectedLocationFormGroup = locationArray.controls[0];
        const geometry = selectedLocationFormGroup.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        streetNamingApplication.line = {
            id: 0,
            deleted: false,
            shape: geometryJSON,
            wkid: 102100,
        };
        streetNamingApplication.shape = applicationShape;
    }
    initializeBuildingUseSearchOptions() {
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiStreetNamingConstants.URL}/${jobId}/${ApiStreetNamingConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService }
    ];
};
SnStrategyService = SnStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], SnStrategyService);
export { SnStrategyService };
